import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";
// import Pusher from "pusher-js";
import { connect } from "react-redux";
import { logOut } from "../../containers/LoginContainer/action";
import { fetchtandc } from "../../containers/SignUpContainer/action";
import { pusher } from "../../service/pusher";
import {
  /* fetchnotifications, */ unreadnotifications /* ,unshownNotifications */
} from "../../containers/NotificationContainer/action";
import {
  fetchOrdersfromChemist,
  fetchUrgentOrders,
  processednormalOrdersList,
  processedurgentOrdersList,
  deliverednormalOrdersList,
  deliveredurgentOrdersList,
  cancellednormalOrdersList,
  cancelledurgentOrdersList,
  orderReturnList
} from "../../containers/DashboardContainer/action";
import {
  fetchNormalOrders,
  inprogressOrders,
  cancelledOrders,
  deliveredOrders
} from "../../containers/NormalOrdersContainer/action";
import {
  fetchChemistOrders,
  fetchChemistInprogressOrders,
  fetchChemistCompletedOrders,
  fetchChemistCancelledOrders
} from "../../containers/OrdersContainer/action";
import { fetchPurchaseReturns } from "../../containers/PurchaseReturnsContainer/action";
import { getSupportTickets } from "../../containers/SupportContainer/action";
import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

class DefaultLayout extends Component {
  pusherEventsBound = false;

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  signOut(e, pusher) {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    pusher.unsubscribe(userDetails.id);
    // console.log(pusher);

    e.preventDefault();
    this.props.logoutaction();
    this.props.history.push("/login");
  }

  componentWillUnmount() {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if(userDetails){
      const pusherchannel = pusher.channel(userDetails.id);
      if (pusherchannel) {
        pusherchannel.unbind();
      }
      pusher.unsubscribe(userDetails.id);
    }
    this.pusherEventsBound = false;
  }

  render() {
    // console.log(this.props.tnc);
    // console.log(this.props.notifications);
    const user = localStorage.getItem("UserRole");

    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const sidebarNavigation =
      userDetails && userDetails.role === "employee"
        ? {
            ...navigation,
            items: navigation.items.filter((item) => item.name !== "Users"),
          }
        : navigation;
    // console.log(userDetails);

    const this2 = this;
    // const pusher = new Pusher("1fed1b5bb402ad82467e", {
    //   cluster: "ap2",
    // });
    if (userDetails) {
      const pusherchannel = pusher.subscribe(userDetails && userDetails.id);
      // console.log(pusherchannel);
      if (!this.pusherEventsBound) {
        pusherchannel.unbind();
        this.pusherEventsBound = true;

      pusherchannel.bind("chemistDPurchase", function(data) {
        this2.props.fetchOrdersfromChemist();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDPurchase", function(data) {
        this2.props.fetchUrgentOrders();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDAccept", function(data) {
        this2.props.processednormalOrdersList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDAccept", function(data) {
        this2.props.processedurgentOrdersList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDDelivered", function(data) {
        this2.props.deliveredurgentOrdersList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDDelivered", function(data) {
        this2.props.deliverednormalOrdersList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDOrderCancel", function(data) {
        this2.props.cancellednormalOrdersList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDOrderCancel", function(data) {
        this2.props.cancelledurgentOrdersList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("return", function(data) {
        this2.props.orderReturnList();
        this2.props.unreadnotifications();
      });

      pusherchannel.bind("chemistDPurchase", function(data) {
        this2.props.fetchNormalOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDAccept", function(data) {
        this2.props.fetchNormalOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
        this2.props.inprogressOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDOrderCancel", function(data) {
        this2.props.fetchNormalOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
        this2.props.cancelledOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDDelivered", function(data) {
        this2.props.deliveredOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDPurchase", function(data) {
        this2.props.fetchChemistOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDAccept", function(data) {
        this2.props.fetchChemistOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
        this2.props.fetchChemistInprogressOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDDelivered", function(data) {
        this2.props.fetchChemistCompletedOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("chemistDOrderCancel", function(data) {
        this2.props.fetchChemistOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });

        this2.props.fetchChemistCancelledOrders({
          page: undefined,
          searchKey: "",
          filter: ""
        });
      });

      pusherchannel.bind("return", function(data) {
        this2.props.fetchPurchaseReturns({
          page: undefined,
          filter: "",
          searchquery: ""
        });
      });

      pusherchannel.bind("sprtTcktClosed", function(data) {
        this2.props.getSupportTickets({
          page: undefined,
          filter: ""
        });
      });

      pusherchannel.bind("sprtTcktInprogress", function(data) {
        this2.props.getSupportTickets({
          page: undefined,
          filter: ""
        });
      });
      }

      /*const this2 = this;
    const pusher = new Pusher("1fed1b5bb402ad82467e", {
      cluster: "ap2"
    });

    var purchaseOrders;var purchaseReturns;
    purchaseOrders=purchaseReturns = pusher.subscribe(user.id); */
      return (
        <div className="app">
          <AppHeader fixed>
            <Suspense fallback={this.loading()}>
              <DefaultHeader
                onLogout={e => this.signOut(e, pusher)}
                fetchnotifications={this.props.fetchnotifications}
                unreadnotifications={this.props.unreadnotifications}
                /* notifications={this.props.notifications}
              notificationcount={this.props.notificationCount}
              unreadnotificationsdata={this.props.unreadnotificationsdata} */
                unreadnotificationcount={this.props.unreadnotificationcount}
                /* unshownNotifications={this.props.unshownNotifications}
              unshownnotificationsdata={this.props.unshownnotificationsdata}
              unshownnotificationsCount={this.props.unshownnotificationsCount} */
              />
            </Suspense>
          </AppHeader>
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader />
              <AppSidebarForm />
              <Suspense>
                <AppSidebarNav
                  navConfig={sidebarNavigation}
                  router={router}
                />
              </Suspense>
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
            <main className="main">
              {/* <AppBreadcrumb appRoutes={routes} router={router} /> */}
              <Container fluid>
                <Suspense fallback={this.loading()}>
                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props =>
                            localStorage.getItem("token") !== null ? (
                              <route.component {...props} />
                            ) : (
                              <Redirect from="/" to="/login" />
                            )
                          }
                        />
                      ) : null;
                    })}
                    <Redirect from="/" to="/dashboard" />
                  </Switch>
                </Suspense>
              </Container>
            </main>
            <AppAside fixed>
              <Suspense fallback={this.loading()}>
                <DefaultAside />
              </Suspense>
            </AppAside>
          </div>
          <div className="footerappdiv">
            <AppFooter
              style={{
                backgroundColor: "#ffff",
                paddingTop: "10px",
                paddingBottom: "10px"
              }}
            >
              <Suspense fallback={this.loading()}>
                <DefaultFooter
                  fetchtandc={this.props.fetchtandc}
                  tnc={this.props.tnc}
                />
              </Suspense>
            </AppFooter>
          </div>
        </div>
      );
    } else return <Redirect to="/login" />
  }
}

function bindAction(dispatch) {
  return {
    logoutaction: () => {
      dispatch(logOut());
    },
    fetchtandc: () => {
      dispatch(fetchtandc());
    },
    /* fetchnotifications:()=>{
      dispatch(fetchnotifications());
    }, */
    unreadnotifications: () => {
      dispatch(unreadnotifications());
    },
    /* unshownNotifications:()=>{
      dispatch(unshownNotifications());
    }, */
    fetchOrdersfromChemist: () => {
      dispatch(fetchOrdersfromChemist());
    },
    fetchUrgentOrders: () => {
      dispatch(fetchUrgentOrders());
    },
    processednormalOrdersList: () => {
      dispatch(processednormalOrdersList());
    },
    processedurgentOrdersList: () => {
      dispatch(processedurgentOrdersList());
    },
    deliverednormalOrdersList: () => {
      dispatch(deliverednormalOrdersList());
    },
    deliveredurgentOrdersList: () => {
      dispatch(deliveredurgentOrdersList());
    },
    cancellednormalOrdersList: () => {
      dispatch(cancellednormalOrdersList());
    },
    cancelledurgentOrdersList: () => {
      dispatch(cancelledurgentOrdersList());
    },
    orderReturnList: () => {
      dispatch(orderReturnList());
    },
    fetchNormalOrders: value => {
      dispatch(fetchNormalOrders(value));
    },
    inprogressOrders: value => {
      dispatch(inprogressOrders(value));
    },
    cancelledOrders: value => {
      dispatch(cancelledOrders(value));
    },
    deliveredOrders: value => {
      dispatch(deliveredOrders(value));
    },
    fetchChemistOrders: value => {
      dispatch(fetchChemistOrders(value));
    },
    fetchChemistInprogressOrders: value => {
      dispatch(fetchChemistInprogressOrders(value));
    },
    fetchChemistCompletedOrders: value => {
      dispatch(fetchChemistCompletedOrders(value));
    },
    fetchChemistCancelledOrders: value => {
      dispatch(fetchChemistCancelledOrders(value));
    },
    fetchPurchaseReturns: value => {
      dispatch(fetchPurchaseReturns(value));
    },
    getSupportTickets: value => {
      dispatch(getSupportTickets(value));
    }
  };
}

function mapStateToProps(state) {
  return {
    tnc: state.SignupReducer.tnc,
    /* notifications:state.NotificationsReducer.notifications,
    notificationCount:state.NotificationsReducer.notificationCount, 
    unreadnotificationsdata:state.NotificationsReducer.unreadnotificationsdata,*/
    unreadnotificationcount: state.NotificationsReducer.unreadnotificationCount
    /* unshownnotificationsdata:state.NotificationsReducer.unshownnotificationsdata,
    unshownnotificationsCount:state.NotificationsReducer.unshownnotificationsCount */
  };
}

export default connect(
  mapStateToProps,
  bindAction
)(DefaultLayout);
